"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var vue_1 = require("vue");
var dateFilter = function (value, format, retainTimeZoneOffset, utc) {
    if (retainTimeZoneOffset === void 0) { retainTimeZoneOffset = false; }
    if (utc === void 0) { utc = false; }
    if (!value)
        return "";
    var momentDate;
    if (retainTimeZoneOffset)
        momentDate = moment.parseZone(value);
    else if (utc)
        momentDate = moment.utc(value);
    else
        momentDate = moment(value);
    if (!format)
        return momentDate.format("MM/DD/YYYY");
    return momentDate.format(format);
};
vue_1.default.filter("formatDate", dateFilter);
